module.exports = __webpack_public_path__ + "static/auto-hands-db50162fd0f05cdb8c0e31da60647cb5.jpg";